import $ from 'jquery';

function init() {
  cartClick()
}

function cartClick() {
  $('.prodCard-cart').click(function(e) {
    e.preventDefault()

    let variant = $(this).data('id')

    $.post('/cart/add.js', {
      quantity: 1,
      id: variant
    }).done(res => {
      const data = JSON.parse(res)
      cart.open = true
      $('.nav-cartQty').text(data.quantity).addClass('nav-cartQty--visible')
    }).fail(err => {
      console.error(err, 'error')
    })
  })
}

$(document).ready(function () {
  init()
})
